module.exports = __webpack_public_path__ + "static/media/spring-background.b56cb7f8.png";